import {selectItemTypes} from '@explorer/actions/item-types';

export const buildItemTypesActions = storedState => {
  if (storedState.itemTypes) {
    return [
      selectItemTypes(
        storedState.itemTypes
          .filter(item => item.on === true)
          .map(item => item.name)
      ),
    ];
  }
  return [];
};
